import { render, staticRenderFns } from "./warehouse_code.vue?vue&type=template&id=60b40220&scoped=true&"
import script from "./warehouse_code.vue?vue&type=script&lang=js&"
export * from "./warehouse_code.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b40220",
  null
  
)

export default component.exports